import { createContext } from 'react';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';

export type TournamentContextProps = Tournament<Date>;

export const TournamentContext = createContext<TournamentContextProps>(
  null as unknown as Tournament<Date>,
);
